var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showError)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error==''?'服务不可用，请联系管理员':_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }